<template>    
  <div class="content">
 
    <b-container fluid >
      <div>
        <card class="no-border-card pb-0 mb-0" body-classes=" p-4" >

          <b-row class="justify-content-md-center" align-v="center" >
            <b-col>
              <h1 class="mb-0">Outbound Campaigns</h1>
            </b-col>
            <b-col class="float-right" v-if="this.$parent.active_user.permissions.includes('campaigns:create')">
              <base-button icon type="success" class="float-right"  @click="toggle_new_campaign_modal" >
                <span class="btn-inner--icon"><span class="material-icons material-icons-outlined md-18 color_white">add</span></span>
                <span class="btn-inner--text">Create Campaign</span>
              </base-button>
            </b-col>
          </b-row>
        </card>

        <!-- campaigns table -->
        <card class="no-border-card" body-classes="px-0 pb-1 pt-0 mt-o" footer-classes="pb-2">
          <div>
           <ve-table :columns="columns" :table-data="tableData" :fixed-header="true" ref="campaigns_table" ></ve-table>
             <div class="table-pagination mt-3">
                <ve-pagination
                    :total="totalCount"
                    :page-index="pageIndex"
                    :page-size="pageSize"
                    @on-page-number-change="pageNumberChange"
                    @on-page-size-change="pageSizeChange"
                />
            </div>

          </div>
        </card>
        <!-- campaigns table -->

      </div>

      <!-- new campaign modal -->
      <div>
      
        <modal :show.sync="modals.new_campaign.show_modal" class="modal-xl" body-classes="p-0" id="new_campaign_modal" ref="new_campaign_modal">


          <card 
                header-classes="bg-transparent pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0 mb-0">

              <div class="text-muted text-center mt-2 mb-3">
                <h2>Create New Campaign</h2>
              </div>

              <div v-if="modals.new_campaign.errors.length > 0">
                <!-- v-bind:key="modals.new_campaign.errors -->
                <b-alert show variant="danger" v-for="new_campaign_errors in modals.new_campaign.errors" v-bind:key="new_campaign_errors" :error_text="new_campaign_errors" >
                  <strong>{{new_campaign_errors}}</strong>
                </b-alert>
              </div>

              <b-form role="form">
                <base-input alternative
                            v-model="modals.new_campaign.form_data.campaign_name"
                            class="mb-3"
                            placeholder="Campaign Name"
                            prepend-icon="drive_file_rename_outline">
                </base-input>
                
                <b-form-group label="Active" style="font-weight: 600;font-size: 0.875rem;" class="mb-2">
                  <base-switch class="mr-1" v-model="modals.new_campaign.form_data.active_campaign"></base-switch>
                </b-form-group>

                <base-input label="Message Service">
                <!-- TODO need to add a short name active_messenger_service -->
                  <el-select v-model="new_active_messenger_service_sid" filterable
                            placeholder="Type">
                    <el-option v-for="message_service in $parent.message_services"
                              :key="message_service.messaging_service_sid"
                              :label="message_service.messenger_service_name"
                              :value="message_service.messaging_service_sid">
                    </el-option>
                  </el-select>
                </base-input>

                <base-input label="Number">
                  <el-select v-model="modals.new_campaign.form_data.phone_number" filterable
                            placeholder="Type">
                    <el-option v-for="numbers in $parent.array_of_numbers"
                              :key="numbers"
                              :label="numbers"
                              :value="numbers">
                    </el-option>
                  </el-select>
                </base-input>
                <p>If you do not choose a number mesages will be polled for *all* numbers within the messenger service.</p>

               
                <base-input label="Scripts">
                  <el-select v-model="modals.new_campaign.form_data.scripts" filterable multiple 
                            placeholder="Scripts"> 
                    <el-option v-for="scripts in $parent.scripts"
                              :key="scripts.script_uuid"
                              :label="scripts.script_name"
                              :value="scripts.script_uuid">
                    </el-option>
                  </el-select>
                </base-input>


                  <base-input label="Lists">
                    <el-select v-model="modals.new_campaign.form_data.list_uuids"
                              multiple
                              filterable
                              >
                      <el-option v-for="contact_lists in $parent.contact_lists"
                                :key="contact_lists.list_uuid"
                                :label="contact_lists.list_name"
                                :value="contact_lists.list_uuid">
                      </el-option>
                    </el-select>
                  </base-input>


                  
                
              
              </b-form>

              

          </card>

          
      

         <template slot="footer">
          <base-button type="danger" @click="close_new_campaign_modal()">Cancel</base-button>
          <base-button type="success" @click="submit_new_campaign()" :disabled="modals.new_campaign.is_busy" ref="create_campaign_button">Create Campaign <span v-if="modals.new_campaign.is_busy" class="material-icons material-icons-outlined">hourglass_empty</span> </base-button>
          

        </template>
        </modal>


      </div>


      <!-- edit lists modal -->
      <div>
        <modal :show.sync="edit_lists_modal.show_modal" class="modal-xl" body-classes="p-0" id="edit_lists_modal" ref="edit_lists_modal">
          <card 
                header-classes="bg-transparent pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0 mb-0">

              <div class="text-muted text-center mt-2 mb-3">
                <h2>Edit Campaign Lists</h2>
                <p>{{edit_lists_modal.campaign_name}}</p>
              </div>

              <b-form role="form">
                <base-input label="Lists">
                  <el-select v-model="edit_lists_modal.list_uuids"
                            multiple
                            filterable
                            >
                    <el-option v-for="contact_lists in $parent.contact_lists"
                              :key="contact_lists.list_uuid"
                              :label="contact_lists.list_name"
                              :value="contact_lists.list_uuid">
                    </el-option>
                  </el-select>
                </base-input>
              </b-form>
          </card>

          
      

         <template slot="footer">
            <base-button type="danger" @click="close_edit_lists_modal()">Cancel</base-button>
            <base-button type="success" @click="edit_lists_send()" :disabled="edit_lists_modal.is_busy" ref="edit_lists_button">Update Lists <span v-if="edit_lists_modal.is_busy" class="material-icons material-icons-outlined">hourglass_empty</span> </base-button>
          </template>
        </modal>
      </div>


      <!-- edit scripts modal -->
      <div>
        <modal :show.sync="edit_scripts_modal.show_modal" class="modal-xl" body-classes="p-0" id="edit_scripts_modal" ref="edit_scripts_modal">
          <card 
                header-classes="bg-transparent pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0 mb-0">

              <div class="text-muted text-center mt-2 mb-3">
                <h2>Edit Campaign Scripts</h2>
                <p>{{edit_scripts_modal.campaign_name}}</p>
              </div>

              <b-form role="form">
                <base-input label="Scripts">
                  <el-select v-model="edit_scripts_modal.scripts"
                            multiple
                            filterable
                            >
                    <el-option v-for="scripts in $parent.scripts"
                              :key="scripts.script_uuid"
                              :label="scripts.script_name"
                              :value="scripts.script_uuid">
                    </el-option>
                  </el-select>
                </base-input>
              </b-form>
          </card>

          
      

         <template slot="footer">
            <base-button type="danger" @click="close_edit_scripts_modal()">Cancel</base-button>
            <base-button type="success" @click="edit_scripts_send()" :disabled="edit_scripts_modal.is_busy" ref="edit_scripts_button">Update Scripts <span v-if="edit_scripts_modal.is_busy" class="material-icons material-icons-outlined">hourglass_empty</span> </base-button>
          </template>
        </modal>
      </div>
      <!-- end edit scripts modal -->


    </b-container>
    </div>
</template>
<script>
import { Select, Option, Container } from 'element-ui'
import swal from 'sweetalert2';
import { BModal } from 'bootstrap-vue'
import VueEasytable  from "vue-easytable";
import moment from 'moment'

//import sub_select from "./select.vue"


export default {
  name:'campaigns_new',
  components: {
    BModal,
    VueEasytable,
    //sub_select,
    [Select.name]: Select,
    [Option.name]: Option,
    //Option: 'el-option',
    //Select: 'el-select'
  },
  data() {
    return {
      //pagination:{},
      new_active_messenger_service_sid: this.$parent.active_messenger_service.messenger_service_sid,
      is_inside_change_data_callback: false,
      changed_row_index_numbers: [],

      pageIndex: 1,
      pageSize:10,

      columns: [
        /*
        {
            field: "",
            key: "a",
            title: "",
            width: 50,
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              if(this.pageIndex === 1) {
                return ++rowIndex
              } else {
                rowIndex = rowIndex +1
                return (this.pageSize*(this.pageIndex-1))+rowIndex
              }
            },
        },*/
        {
            field: "campaign_name",
            key: "campaign_uuid",
            title: "Name",
            align: "left",
            width: 120,
            renderBodyCell: ({ row, column, index }, h) => {
              //return new Date(row.date_created).toDateString();
             
              return (
                <div v-b-tooltip={moment(row.date_created).format('MM/DD/YYYY')}>{row.campaign_name}
                </div>
              )
            }
            
        },
        {
            field: "date_created",
            key: "date_created",
            title: "Date",
            align: "left",
            width: 90,
            renderBodyCell: ({ row, column, index }, h) => {
              //return new Date(row.date_created).toDateString();
              return moment(row.date_created).format('MM/DD/YYYY');
            }
        },

        {
            field: "is_active",
            key: "is_active",
            title: "Active",
            align: "left",
            width: 80,
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              
              let real_row_index
              if(this.pageIndex === 1) {
                real_row_index = ++rowIndex
              } else {
                rowIndex = rowIndex +1
                real_row_index = (this.pageSize*(this.pageIndex-1))+rowIndex
              }
      
              return (
              
                <div slot-scope="{real_row_index, row}" class="d-flex" >
                  <base-switch class="mr-1" v-model={this.$parent.outbound_campaigns[real_row_index-1].is_active}  onTrigger_function={() => this.change_this_active_status((real_row_index-1),this.$parent.outbound_campaigns[real_row_index-1])}  ></base-switch> 
                </div>
                
              )
                //return <is_active_switch row={row} index={index} />;
                
              
            }
        },

        {
          field: "list_script_edit",
          key: "list_script_edit",
          title: "Lists & Scripts",
          width: 150,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            let real_row_index
            if(this.pageIndex === 1) {
              real_row_index = ++rowIndex
            } else {
              rowIndex = rowIndex +1
              real_row_index = (this.pageSize*(this.pageIndex-1))+rowIndex
            }

            let number_lists = 0
            let this_lists_pill_width = 'padding-left: 0.875em;padding-right: 0.875em;'
            let calculate_lists_pill_ratio = .875
            if(typeof row !== 'undefined' && typeof row.list_uuids !== 'undefined') {
              if(row.list_uuids.length && row.list_uuids.length > 0)  {
                number_lists= row.list_uuids.length
                calculate_lists_pill_ratio = calculate_lists_pill_ratio + ((calculate_lists_pill_ratio/3)*number_lists)
                this_lists_pill_width = 'padding-left: '+calculate_lists_pill_ratio+'em;padding-right: '+calculate_lists_pill_ratio+'em;'

              }
            }

            let number_scripts = 0
            let this_script_pill_width = 'padding-left: 0.875em;padding-right: 0.875em;'
            let calculate_ratio = .875
            if(typeof row !== 'undefined' && typeof row.scripts !== 'undefined') {
              if(row.scripts.length && row.scripts.length > 0)  {
                number_scripts= row.scripts.length

                if(number_scripts > 0) {

                  calculate_ratio = calculate_ratio + ((calculate_ratio/3)*number_scripts)
                  this_script_pill_width = 'padding-left: '+calculate_ratio+'em;padding-right: '+calculate_ratio+'em;'

                }
              }
            }

            
            return (
              <div>
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center " onClick={() => this.edit_lists((real_row_index-1),row)}>
                    Lists 
                    <b-badge variant="primary" pill style={this_lists_pill_width} class="left_5px">{number_lists}</b-badge>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex justify-content-between align-items-center " onClick={() => this.edit_scripts((real_row_index-1),row)}>
                    Scripts 
                    <b-badge variant="primary" pill style={this_script_pill_width} class="left_5px">{number_scripts}</b-badge>
                  </b-list-group-item>
                </b-list-group>
              </div>

              
              
            )
            
          }
        },

        {
          field: "sent_number",
          key: "sent_number",
          title: "Sent",
          align: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            try {

              if(typeof this.$parent.stats.all_time_outbound_campaigns_complex_stats === 'undefined') {
                console.log('no complex stats')
                return
              } else if(typeof this.$parent.stats.all_time_outbound_campaigns_complex_stats[row.outbound_campaign_uuid] !== 'undefined') {

                let good_count = 0
                let bad_count = 0
                let yellow_count = 0
                let all_count = 0
                let max = 0

                if(this.$parent.stats.all_time_outbound_campaigns_complex_stats[row.outbound_campaign_uuid].length && this.$parent.stats.all_time_outbound_campaigns_complex_stats[row.outbound_campaign_uuid].length > 0) {
                  this.$parent.stats.all_time_outbound_campaigns_complex_stats[row.outbound_campaign_uuid].forEach(single_row => {

                    if(typeof single_row['unique_messages']) {
                      all_count = all_count + single_row['unique_messages']
                    }

                    if(typeof single_row['failed']) {
                      bad_count = bad_count + single_row['failed']
                    }
                    if(typeof single_row['undelivered']) {
                      bad_count = bad_count + single_row['undelivered']
                    }

                    if(typeof single_row['delivery_unknown']) {
                      yellow_count = yellow_count + single_row['delivery_unknown']
                    }

                    if(typeof single_row['delivered']) {
                      good_count = good_count + single_row['delivered']
                    }
                    if(typeof single_row['sent']) {
                      good_count = good_count + single_row['sent']
                    }
                  });
                }

                try {
                  //if(this.$parent.contact_lists_stats)
                } catch(e) {
                  console.log(e)
                }

                if(max === 0 || max === null) {
                  max=good_count+yellow_count+bad_count
                }


                //TODO how to get combined list sizes.. maybe it's easier to pull on the backend a join to get the combined list numbers? they're not correct anyways because there will or can be dupes on sent_to...
             
                //this.campaign_stats_object[row.outbound_campaign_uuid].lists_sizes

                return (
                  <div>
                    <b-container class="bv-example-row campaigns_sent ">
                      <b-progress class="" max={max} show-value>
                        <b-progress-bar value={good_count} variant="success"></b-progress-bar>
                        <b-progress-bar value={yellow_count} variant="warning"></b-progress-bar>
                        <b-progress-bar value={bad_count} variant="danger" ></b-progress-bar>
                      </b-progress>
                    </b-container>
                  </div>

                )
              } else {
                return
              }

            } catch(e) {
              console.log(e)
              return
            }
            
          }
        }

      ],

      edit_lists_modal: {
        show_modal:false,
        is_busy:false,
        list_uuids: [],
        index: null,
        campaign_name:null
      },
      edit_scripts_modal: {
        show_modal:false,
        is_busy:false,
        scripts: [],
        index:null,
        campaign_name: null
      },
      modals: {
        new_campaign: {
          show_modal: false,
          is_busy: false,
          errors: [

          ],
          default_form_data: {
            
            "org_id":this.$parent.active_org.org_id,
            "front_team_id":this.$parent.active_org.front_team_id,
            //"outbound_campaign_uuid":null,
            "list_uuids":[],
            "outbound_campaign_type":"SMS",
            "status":"draft",
            //"date_created":,
            //"last_modified":,
            "is_active":true,
            "user_uuid_last_modified":this.$parent.active_user.user_uuid,
            "user_uuid_created":this.$parent.active_user.user_uuid,
            "campaign_name":null,
            "scripts":[
              
            ],
            "messaging_service_sid":this.$parent.active_messenger_service.messaging_service_sid,
            "phone_number":null,
            //"phone_number_sid":null
            
          },
          form_data: {
            "org_id":this.$parent.active_org.org_id,
            "front_team_id":this.$parent.active_org.front_team_id,
            //"outbound_campaign_uuid":null,
            "list_uuids":[],
            "outbound_campaign_type":"SMS",
            "status":"draft",
            //"date_created":,
            //"last_modified":,
            "is_active":true,
            "user_uuid_last_modified":this.$parent.active_user.user_uuid,
            "user_uuid_created":this.$parent.active_user.user_uuid,
            "campaign_name":null,
            "scripts":[
              
            ],
            "messaging_service_sid":this.$parent.active_messenger_service.messaging_service_sid,
            "phone_number":null,
            //"phone_number_sid":null
          }
        }
      }
    };
  },
  computed: {
    totalCount() {
        return this.$parent.outbound_campaigns.length || 0
    },
    tableData() {
        const { pageIndex, pageSize } = this;
        return this.$parent.outbound_campaigns.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    },
    
    /*
    campaign_stats_object() {
      try {

        let this_lists_object = {}
        if(typeof this.$parent.contact_lists_stats !== 'undefined' && this.$parent.contact_lists_stats.length > 0 ) {
          this.$parent.contact_lists_stats.forEach(single_list_stat => {
            if(typeof single_list_stat.list_uuid !== 'undefined' && single_list_stat.list_uuid && single_list_stat.list_uuid !== null && single_list_stat.list_uuid !=='' && single_list_stat.list_uuid !=='error') {
              this_lists_object[single_list_stat.list_uuid] = single_list_stat
            }
          });
        } else {
          console.log('parent stats empty or null')
        }

        let object_of_outbound_campaigns = {}
        if(typeof this.$parent.outbound_campaigns !== 'undefined' && this.$parent.outbound_campaigns.length && this.$parent.outbound_campaigns .length > 0) {
          this.$parent.outbound_campaigns .forEach(outbound_campaign => {

            if(typeof outbound_campaign.outbound_campaign_uuid !== 'undefined' && outbound_campaign.outbound_campaign_uuid && outbound_campaign.outbound_campaign_uuid !== null && outbound_campaign.outbound_campaign_uuid !== '') {
              object_of_outbound_campaigns[outbound_campaign.outbound_campaign_uuid] = outbound_campaign
            }
            
          });
        } else {
          console.log('outbound campaigns null or empty')
        }
        


        if(typeof this.$parent.outbound_campaigns_stats !== 'undefined') {

          if(this.$parent.outbound_campaigns_stats.length && this.$parent.outbound_campaigns_stats.length > 0) {
        
            let object_of_stats_key_is_campaign_uuid = {}

            this.$parent.outbound_campaigns_stats.forEach(campaign_stat => {

              let this_stat_merge_object = campaign_stat
              //ok have to look at the lists in this

              if(
                typeof object_of_outbound_campaigns[campaign_stat.outbound_campaign_uuid] !== 'undefined'
                && typeof object_of_outbound_campaigns[campaign_stat.outbound_campaign_uuid].list_uuids !== 'undefined'
                && object_of_outbound_campaigns[campaign_stat.outbound_campaign_uuid].list_uuids.length
                && object_of_outbound_campaigns[campaign_stat.outbound_campaign_uuid].list_uuids.length > 0
              ) {

                let combined_list_sizes = 0

                object_of_outbound_campaigns[campaign_stat.outbound_campaign_uuid].list_uuids.forEach(single_list_uuid => {

                  if(typeof this_lists_object[single_list_uuid] !== 'undefined' && this_lists_object[single_list_uuid] !== null) {

                    if(typeof this_lists_object[single_list_uuid].twilio_verified_cell  !== 'undefined') {
                      combined_list_sizes =  combined_list_sizes + this_lists_object[single_list_uuid].twilio_verified_cell 
                    } else {
                       combined_list_sizes =  combined_list_sizes + 0
                    }
                    
                  }
                  
                });

                this_stat_merge_object['lists_sizes'] = combined_list_sizes
              } else {
                this_stat_merge_object['lists_sizes'] = 0
              }

              object_of_stats_key_is_campaign_uuid[campaign_stat.outbound_campaign_uuid] = campaign_stat

            });
            return object_of_stats_key_is_campaign_uuid
          } else {
            console.log('outbound stats length 0')
            return {}
          }
        } else {
          console.log('no outbound stats?')
          return {}
        }
      } catch(e) {
        console.log(e)
        return {}
      }
    }
    */
  },
  watch: {
    //TODO add a set timeout init var to disable phone numbers drop down until the parent function is finished
    new_active_messenger_service_sid: {
      handler: function(newVal,oldVal) {
        console.log('debug 936 new new_active_messenger_service_sid')
        if(newVal && newVal !== null && typeof newVal !== 'undefined') {
          this.$parent.set_active_messenger_service(newVal)
        }
      }
    }
  },
  created() {
    window.addEventListener("resize", this.window_resize_function);
    this.window_resize_function()
  },
  destroyed() {
    window.removeEventListener("resize", this.window_resize_function);
  },
  methods: {
    calculate_window_width() {
      var this_width = 0
      if( typeof( window.innerWidth ) == 'number' ) {
        //Non-IE
        this_width = window.innerWidth;
      } else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
        //IE 6+ in 'standards compliant mode'
        this_width = document.documentElement.clientWidth;
      } else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
        //IE 4 compatible
        this_width = document.body.clientWidth;
      }
      return this_width
    },
    //mobile hide date i think
    window_resize_function(event) {
      //if(event.type && event.type === 'resize') {
        let this_width =  this.calculate_window_width() 

        if(this_width <= 600) {
          this.hideColumns(['date_created'],'campaigns_table')
        } else {
          this.showColumns(['date_created'],'campaigns_table')
        } 
      //}
    },
    hideColumns(keys,table_ref) {
      if(typeof keys === 'undefined' || keys === null || typeof table_ref === 'undefined' || table_ref === null ) {
        return null
      }

      //make sure element exists
      this.$nextTick(() => {
        if(typeof  this.$refs[table_ref] !== 'undefined') {
          this.$refs[table_ref].hideColumnsByKeys(keys);
        }
      })
      
    },
    // show cloumns
    showColumns(keys,table_ref) {   //array, campaigns_table
      if(typeof keys === 'undefined' || keys === null || typeof table_ref === 'undefined' || table_ref === null ) {
        return null
      }
      this.$nextTick(() => {
        if(typeof  this.$refs[table_ref] !== 'undefined') {
          this.$refs[table_ref].showColumnsByKeys(keys)
        }
        
      })
    },



    edit_scripts(index,row) {
      try {

        //check state is not messed up
        if(row.campaign_name.toUpperCase() !== this.$parent.outbound_campaigns[index].campaign_name.toUpperCase()) {
          console.log('state does not align?')

          return this.close_edit_scripts_modal('State mismatch error. refresh and contact admin')          
        }

        //set the current state
        this.edit_scripts_modal.scripts = this.$parent.outbound_campaigns[index].scripts
        this.edit_scripts_modal.index = index
        this.edit_scripts_modal.campaign_name = this.$parent.outbound_campaigns[index].campaign_name

        this.edit_scripts_modal.show_modal = true

      } catch(e) {
        console.log(e)
        return this.close_edit_scripts_modal(e)
      }
      
    },
    edit_scripts_send() {
      try {

        //post it here
        //sending
        this.edit_scripts_modal.is_busy = true

        //update the parent
        this.$parent.outbound_campaigns[this.edit_scripts_modal.index].scripts = this.edit_scripts_modal.scripts
        this.$parent.outbound_campaigns[this.edit_scripts_modal.index].last_modified = new Date().getTime()
        this.$parent.outbound_campaigns[this.edit_scripts_modal.index].user_uuid_last_modified = this.$parent.active_user.user_uuid

        axios.post('https://'+this.$parent.use_this_api_domain+'/outbound_campaign/create', this.$parent.outbound_campaigns[this.edit_scripts_modal.index], {
          headers: {
            'Authorization': 'Bearer ' + this.$parent.active_user_jwt
          }
        })
        .then((result,error) => {
          if(result) {
         
            this.$parent.outbound_campaigns[this.edit_scripts_modal.index] = result.data
            //not going to resest the active campaign this time...
            this.close_edit_scripts_modal()
          }
          if(error) {
            console.log('debug update campaign error ')
            console.log(JSON.stringify(error))
            return this.close_edit_scripts_modal(error)
          }

        })
        .catch((error) => {
          if(error){
            console.log(error)
          }
          return this.close_edit_scripts_modal(error || 'error updating campaign')
        })
        
      } catch(e) {
        console.log(e)
        return this.close_edit_scripts_modal(e)
      }
    },
    close_edit_scripts_modal(send_error) {

      if(typeof send_error !== 'undefined' && send_error !== null) {
        return swal.fire({
          title: `Warning`,
          text: send_error,
          buttonsStyling: false,
          icon: 'warning'
        })
      }

      //reset on done
      this.edit_scripts_modal.is_busy = false
      this.edit_scripts_modal.index = null
      this.edit_scripts_modal.show_modal = false
      this.edit_scripts_modal.scripts = []
      this.edit_scripts_modal.campaign_name = null
    },






    edit_lists(index,row) {
      try {

        //check state is not messed up
        if(row.outbound_campaign_uuid.toUpperCase() !== this.$parent.outbound_campaigns[index].outbound_campaign_uuid.toUpperCase()) {
          console.log('state does not align?')

          return this.close_edit_lists_modal('State mismatch error. refresh and contact admin')          
        }

        //set the current state
        this.edit_lists_modal.list_uuids = this.$parent.outbound_campaigns[index].list_uuids
        this.edit_lists_modal.index = index
        this.edit_lists_modal.campaign_name = this.$parent.outbound_campaigns[index].campaign_name

        this.edit_lists_modal.show_modal = true

      } catch(e) {
        console.log(e)
        return this.close_edit_lists_modal(e)
      }
      
    },
    edit_lists_send() {
      try {

        //post it here
        //sending
        this.edit_lists_modal.is_busy = true

        //update the parent
        this.$parent.outbound_campaigns[this.edit_lists_modal.index].list_uuids = this.edit_lists_modal.list_uuids
        this.$parent.outbound_campaigns[this.edit_lists_modal.index].last_modified = new Date().getTime()
        this.$parent.outbound_campaigns[this.edit_lists_modal.index].user_uuid_last_modified = this.$parent.active_user.user_uuid

        axios.post('https://'+this.$parent.use_this_api_domain+'/outbound_campaign/create', this.$parent.outbound_campaigns[this.edit_lists_modal.index], {
          headers: {
            'Authorization': 'Bearer ' + this.$parent.active_user_jwt
          }
        })
        .then((result,error) => {
          if(result) {
           
            this.$parent.outbound_campaigns[this.edit_scripts_modal.index] = result.data
            //not going to resest the active campaign this time...
            this.close_edit_lists_modal()
          }
          if(error) {
            console.log('debug update campaign error ')
            console.log(JSON.stringify(error))
            return this.close_edit_lists_modal(error)
          }

        })
        .catch((error) => {
          if(error){
            console.log(error)
          }
          return this.close_edit_lists_modal(error || 'error updating campaign')
        })
        
      } catch(e) {
        console.log(e)
        return this.close_edit_lists_modal(e)
      }
    },
    close_edit_lists_modal(send_error) {

      if(typeof send_error !== 'undefined' && send_error !== null) {
        return swal.fire({
          title: `Warning`,
          text: send_error,
          buttonsStyling: false,
          icon: 'warning'
        })
      }

      //reset on done
      this.edit_lists_modal.is_busy = false
      this.edit_lists_modal.index = null
      this.edit_lists_modal.show_modal = false
      this.edit_lists_modal.list_uuids = []
      this.edit_lists_modal.campaign_name = null
    },


    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },

    change_this_active_status: function(index,row) {
      console.log('change_this_active_status')
      console.log(index)
     
      this.$nextTick(() => {
        //so dont do two at once
        if(!this.changed_row_index_numbers.includes(index)) {
          this.changed_row_index_numbers.push(index)
          this.post_new_row_data(index,row,0)
        } else {
          return swal.fire({
              title: `Warning`,
              text: 'Error previous request still loading refresh and try again',
              buttonsStyling: false,
              icon: 'warning'
            })
        }
      })
    },
    removeItemAll: function(arr, value) {
      var i = 0;
      while (i < arr.length) {
        if (arr[i] === value) {
          arr.splice(i, 1);
        } else {
          ++i;
        }
      }
      return arr;
    },
    post_new_row_data: function(index,row,attempts) {
      //let this_row_elements = document.getElementsByClassName("el-table__row")
      //this_row_elements[index].classList.add("table_row_loading");

      try {
       
          row.user_uuid_last_modified = this.$parent.active_user.user_uuid
          if(this.$parent.active_user && this.$parent.active_user.permissions && !this.$parent.active_user.permissions.includes('campaigns:create')) {
            return
          }
          if(attempts && attempts > 1) {
            console.log('426 attempts ' + attempts)
            console.log('state didnt align did not post this data?')
            console.log(index)
            console.log(JSON.stringify(row))
            console.log(JSON.stringify(this.$parent.outbound_campaigns[index]))
            this.removeItemAll(this.changed_row_index_numbers,index)
            return swal.fire({
              title: `Warning`,
              text: 'Stat error. This did not save. Refresh to try again and contact admin.',
              buttonsStyling: false,
              icon: 'warning'
            })
          }

          //what about a check because the computed state seems to take a bit?
          this.$nextTick(() => {
            if(JSON.stringify(row) !== JSON.stringify(this.$parent.outbound_campaigns[index]) ) {
              console.log('debug 429 state does not match? timeout?')
              console.log(JSON.stringify(row))
              console.log(JSON.stringify(this.$parent.outbound_campaigns[index]))

              setTimeout(() => {
                return this.post_new_row_data(index,row,(attempts+1))
              }, 1000);
            } else {
              
                axios.post('https://'+this.$parent.use_this_api_domain+'/outbound_campaign/create', row, {
                  headers: {
                    'Authorization': 'Bearer ' + this.$parent.active_user_jwt
                  }
                })
                .then((result,error) => {
                  if(result) {
                    console.log('should match')
                    console.log(JSON.stringify(this.$parent.outbound_campaigns[index]))
                    console.log(JSON.stringify(result.data))

                    this.$parent.cascade_updates_on_new_active_campaign(null,null,0,1000,result.data.outbound_campaign_uuid)

                  }
                  if(error) {
                    console.log('debug update campaign error ')
                    console.log(JSON.stringify(error))
                  }

                  this.removeItemAll(this.changed_row_index_numbers,index)

                  this.$parent.active_outbound_campaign_uuid = result.data.outbound_campaign_uuid

                })
                
            }
          })

          
       

      } catch(e) {
        console.log(e)
        this.removeItemAll(this.changed_row_index_numbers,index)
      }
    },
    toggle_new_campaign_modal: function() {
      this.modals.new_campaign.show_modal = true
      //this.$refs['new_campaign_modal'].toggle('#toggle_new_campaign_modal')
    },
    close_new_campaign_modal: function() {
      //reset the data
      this.modals.new_campaign.form_data = this.modals.new_campaign.default_form_data 

      //clear any erors 
      this.modals.new_campaign.errors = []
      //close
      this.modals.new_campaign.show_modal = false
      this.modals.new_campaign.is_busy = false

    },
    submit_new_campaign: function(this_event) {
      
      console.log('submiting this campaign: ')
      console.log(this.modals.new_campaign.form_data)
      

      //make sure has a few details
      

      //211215 allow phone number or messsage service
      if(!this.modals.new_campaign.form_data.phone_number && !this.new_active_messenger_service_sid) {
        this.modals.new_campaign.errors.push("Must select a number or message service to send messages from")
      } else {
        this.modals.new_campaign.errors = this.modals.new_campaign.errors.filter(e => e !== "Must select a number or message service to send messages from")
      }

      this.modals.new_campaign.messenger_service_sid = this.new_active_messenger_service_sid
      

      if(!this.modals.new_campaign.form_data.campaign_name) {
        this.modals.new_campaign.errors.push("Must have a campaign name")
      } else  {
        this.modals.new_campaign.errors = this.modals.new_campaign.errors.filter(e => e !== "Must have a campaign name")
      }

      if(this.modals.new_campaign.form_data.campaign_name && this.modals.new_campaign.form_data.campaign_name.length < 7) {
        this.modals.new_campaign.errors.push("Please write a longer campaign name, at least 8 characters")
      } else {
        this.modals.new_campaign.errors = this.modals.new_campaign.errors.filter(e => e !== "Please write a longer campaign name, at least 8 characters")
      }

      if(!this.modals.new_campaign.form_data.outbound_campaign_type) {
        this.modals.new_campaign.form_data.outbound_campaign_type = 'SMS'
      }
      
      if(this.modals.new_campaign.form_data.is_active === null) {
        this.modals.new_campaign.errors.push("Must select active status")
      } else {
        this.modals.new_campaign.errors = this.modals.new_campaign.errors.filter(e => e !== "Must select active status")
      }


      if(this.modals.new_campaign.errors.length > 0) {
        //do nothing
        this.modals.new_campaign.is_busy = false
      } else {

        if(this.$parent.active_user && this.$parent.active_user.permissions && !this.$parent.active_user.permissions.includes('campaigns:create')) {
          return
        }

        //add the default data from the base
        //TODO maybe it makes more sense to use a computed but im tired
        this.modals.new_campaign.form_data.org_id =  this.modals.new_campaign.default_form_data.org_id
        this.modals.new_campaign.form_data.front_team_id =  this.modals.new_campaign.default_form_data.front_team_id
        this.modals.new_campaign.form_data.status =  this.modals.new_campaign.default_form_data.status
        this.modals.new_campaign.form_data.user_uuid_last_modified =  this.modals.new_campaign.default_form_data.user_uuid_last_modified
        this.modals.new_campaign.form_data.user_uuid_created =  this.modals.new_campaign.default_form_data.user_uuid_created
        
        
        if(this.modals.new_campaign.form_data.phone_number && this.modals.new_campaign.form_data.phone_number !== null) {

        }

       
        
        if(this.new_active_messenger_service_sid !== null) {
  
          this.modals.new_campaign.form_data.messaging_service_sid = this.new_active_messenger_service_sid
        }
        
        
        //this.modals.new_campaign.form_data.messaging_service_sid =  this.modals.new_campaign.default_form_data.messaging_service_sid


        //show modal as loading
        this.modals.new_campaign.is_busy = true

        //post the data
        axios.post('https://'+this.$parent.use_this_api_domain+'/outbound_campaign/create',  
          this.modals.new_campaign.form_data, {
                headers: {
                  'Authorization': 'Bearer ' + this.$parent.active_user_jwt
                }
              })
        .then(response => {
          console.log(response)
          if(response.status === 200) {
            //add the returned data (so it has timestamps etc) into the table
            console.log('new campaign created')
            console.log(response.data)

            //deep clone
            let this_new_campaign = JSON.parse(JSON.stringify(response.data))

            this.$parent.outbound_campaigns.unshift(this_new_campaign)
            //instead of push add to the start... i dont think i need to add though because it's added above
            //this.tableData.unshift(response.data)

            //if there is no active campaign set one.

            this.$parent.active_campaign = this_new_campaign
            this.$parent.active_outbound_campaign_uuid = this_new_campaign.outbound_campaign_uuid
            //dont need to cascade active parent watch will
            //this.$parent.cascade_updates_on_new_active_campaign(null,null,0,1000,this_new_campaign.outbound_campaign_uuid)

          } else {
             swal.fire({
              title: `Warning`,
              text: 'Error creating new campaign',
              buttonsStyling: false,
              icon: 'warning'
            })
            
            console.log(response.data)
          }

        })
        .catch(error =>  {
          swal.fire({
            title: `Warning`,
            text: 'Error creating new campaign',
            buttonsStyling: false,
            icon: 'warning'
          })
          console.log(error.response.data)
        })
        .finally(has_something => {
          console.log('is done posting new campaign data')
          //close the modal
          //reset the data
          this.modals.new_campaign.form_data = this.modals.new_campaign.default_form_data 

          //clear any erors 
          this.modals.new_campaign.errors = []
          //close
          this.modals.new_campaign.show_modal = false
          this.modals.new_campaign.is_busy = false


        })
      }

    }



  },
  mounted:function() {
    
  }
};


</script>
<style>
.badge-pill {
  font-size: 14px;
  font-weight:bold;
  font-weight: 600;
}
.left_5px {
  margin-left: 5px;
}
.list-group-item:hover,.list-group-item:active {
  cursor: pointer;
  background: var(--blue);
  color:#fff;
}
.list-group-item {
  padding:.5rem;
}
.no-border-card .card-footer{
  border-top: 0;
}
.table_row_loading {
  opacity: .5;

}
div.el-table  .table_row_loading {
  background-color: var(--gray) !important;
}
@media (max-width:600px)  {
  .list-group-item {
    padding:.2rem;
  }
  .ve-table .ve-table-container table.ve-table-content tbody.ve-table-body tr.ve-table-body-tr td.ve-table-body-td, .ve-table .ve-table-container table.ve-table-content tbody.ve-table-body tr.ve-table-expand-tr td.ve-table-body-td {
    padding:5px;
  }
  .campaigns_sent {
    padding: 0 5px;
  }
}
</style>
